import React from "react";

import SipPage from "../SipPage";
import { onlineSalesMeta, onlineSales } from "../variables";

const OnlineSales: React.FC = () => (
  <SipPage meta={onlineSalesMeta} section={onlineSales} />
);

export default OnlineSales;
